export type FormattableServerMessage = {
    message: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    values?: { [key: string]: any };
};

export const serverErrorMessages: Record<string, FormattableServerMessage> = {
    'csrf-token-invalid': {
        message: __(
            "We've detected a problem with your cookie settings. Please enable cookies in your browser and try again."
        ),
    },
    'sso-token-cookie-invalid': {
        message: __(
            "We've detected a problem with your cookie settings. Please enable cookies in your browser and try again."
        ),
    },
    'internal-server-error': {
        message: __(
            'It seems there was a problem. The 99designs development team has been notified and are likely addressing the problem at this very minute. Sit tight, grab a coffee, and hit refresh in a few minutes.'
        ),
    },
};
